'use strict';

/*global services*/
/*global createObjectCallBack*/
/*global nl2br*/

function ConfirmService() {
  this.confirmModal = null;

  this.init();
}

ConfirmService.prototype = $.extend({}, {
  constructor: 'ConfirmService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  normalizeInput: function normalizeInput(data) {
    if (typeof data === 'string') {
      var str = data;

      data = {};
      data.content = str;
    }

    return data;
  },

  clb: function clb(callBack, ret) {
    var _this = this;

    _this.confirmModal.close(function () {
      if (callBack) {
        callBack(ret);
      }
    });

    return _this;
  },

  confirmClb: function confirmClb(callback) {
    var _this = this;

    _this.clb(callback, true);

    return _this;
  },

  rejectClb: function rejectClb(callback) {
    var _this = this;

    _this.clb(callback, false);

    return _this;
  },

  confirm: function confirm(data, callback) {
    var _this = this;

    data = _this.normalizeInput(data);

    var content = data.content;

    if (data.asHtml) {
      content = '<p class="text-center">' + nl2br(content) + '</p>';
    }

    _this.confirmModal.open({
      title: data.title,
      confirmCallBack: createObjectCallBack(_this, 'confirmClb', callback),
      confirmBtnTitle: services.get('translator').trans('yes'),
      rejectCallBack: createObjectCallBack(_this, 'rejectClb', callback),
      rejectBtnTitle: services.get('translator').trans('no'),
      buttonsSize: 'lg',
      width: 'md',
      content: content
    });

    return _this;
  },

  confirmHtml: function confirmHtml(data, callback) {
    var _this = this;

    data = _this.normalizeInput(data);

    data.asHtml = true;

    _this.confirm(data, callback);

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.confirmModal = services.get('confirm');

    _this.registerCallbacks();

    return _this;
  }
});
